import React from 'react';

import { useExternalUsersPage } from '@/hooks/externalUsers/useExternalUsersPage';
import ExternalUsersPageView from '@/pages/ExternalUsersPage/ExternalUsersPageView';

function ExternalUsersPage(): React.ReactElement {
  const { state, handlers } = useExternalUsersPage();

  return (
    <ExternalUsersPageView
      visibleUsers={state.visibleUsers}
      error={state.error}
      searchValue={state.searchValue}
      sortKey={state.sortKey}
      sortDir={state.sortDir}
      deptOrgFilter={state.deptOrgFilter}
      deptOrgOptions={state.deptOrgOptions}
      statusFilter={state.statusFilter}
      pendingDelete={state.pendingDelete}
      showEmptyState={state.showEmptyState}
      showEmptySearchState={state.showEmptySearchState}
      onSearchChange={handlers.onSearchChange}
      onSearchClear={handlers.onSearchClear}
      onSortChange={handlers.onSortChange}
      onDeptOrgFilterChange={handlers.onDeptOrgFilterChange}
      onStatusFilterChange={handlers.onStatusFilterChange}
      onDeleteRequest={handlers.onDeleteRequest}
      onDeleteConfirm={handlers.onDeleteConfirm}
      onDeleteCancel={handlers.onDeleteCancel}
      onRetry={handlers.onRetry}
    />
  );
}

export default ExternalUsersPage;
